var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g({tag:"component",class:_vm.classes,attrs:{"type":"button","href":_vm.href}},_vm.$listeners),[_vm._t("default",null,{"default":""})],2)}
var staticRenderFns = []

export { render, staticRenderFns }